import React from 'react';
import PropTypes from 'prop-types'
import LoadingSpinner from './LoadingSpinner';
import AccessibleIcon from '../common/AccessibleIcon';
const Strings = require('../../../../app/shared/Strings');

const propTypes = {
    onCancel: PropTypes.func,
    loadingText: PropTypes.string,
};
const defaultProps = {};

class LoadingWithCancel extends React.Component {
    constructor(props) {
        super(props);
    }

    render(){
        return (
            <div className="loading-list">
                <span>{this.props.loadingText || (Strings["en"].common.LOADING + "...")}</span>
                <LoadingSpinner />
                { this.props.onCancel ?
                <button className="cancel-loading" title={Strings["en"].common.CANCEL_LC} onClick={this.props.onCancel}>
                    <AccessibleIcon className="fa fa-remove" label={Strings["en"].common.CANCEL_LC} onClick={this.props.onCancel}/>
                </button>
                : null }
            </div>
        )
    }
}

LoadingWithCancel.propTypes = propTypes;
LoadingWithCancel.defaultProps = defaultProps;

export default LoadingWithCancel;
